import config from "../config/server-config";
import { apiClient } from "../api";

export const getQuizData = async () => {
  try {
    const response = await apiClient.get(config.quizPageData, {
      params: { page: "quiz" },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};

export const submitQuizData = async (quizData) => {
  try {
    const response = await apiClient.post(config.submitQuizData, quizData);
    return response.data;
  } catch (error) {
    return false;
  }
};
export const getTimeSlots = async (req) => {
  try {
    const response = await apiClient.get(config.getTimeSlotsData, {
      params: { date: req.date },
    });
    return response.data;
  } catch (error) {
    return false;
  }
};
export const createMeeting = async (req) => {
  try {
    const response = await apiClient.post(config.createMeeting, req);
    return response.data; 
  } catch (error) {
    return false;
  }
};

export const getFaqList = async () => {
  try {
    const queryParams = new URLSearchParams({
      page: "1",
      pageSize: "10000",
    });
    const response = await apiClient.get(config.getFaqList, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    return false;
  }
};


export const getPricingList = async () => {
  try {
    const queryParams = new URLSearchParams({
      page: "1",
      pageSize: "10000",
    });
    const response = await apiClient.get(config.getPricingList, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.log('error', error);
    return false;
  }
};

export const getFooterList = async () => {
  try {
    const queryParams = new URLSearchParams({
      page: "1",
      pageSize: "10000",
    });
    const response = await apiClient.get(config.getFooterData, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.log('error', error);
    return false;
  }
};

// Handle accordion functionality
export const initializeAccordions = () => {
  const accordions = document.querySelectorAll('.accordion1');
  
  accordions.forEach(accordion => {
    accordion.addEventListener('click', function() {
      this.classList.toggle('active');
      const panel = this.nextElementSibling;

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
};

// Handle step navigation
export const showStep = (stepId) => {
  // Hide all steps
  const allSteps = document.querySelectorAll('.step-content');
  allSteps.forEach(step => {
    step.classList.add('hidden');
  });
  
  // Show selected step
  const targetStep = document.getElementById(stepId);
  if (targetStep) {
    targetStep.classList.remove('hidden');
  }
};

// Handle section navigation
export const showSection = (sectionId) => {
  // Hide all sections
  const allSections = document.querySelectorAll('.slide-content');
  allSections.forEach(section => {
    section.style.display = 'none';
  });
  
  // Show selected section
  const targetSection = document.getElementById(sectionId);
  if (targetSection) {
    targetSection.style.display = 'block';
  }
};

// Initialize quiz functionality
export const initializeQuiz = () => {
  // Initialize accordions
  initializeAccordions();
  
  // Handle assist dropdown
  const assistDropdown = document.getElementById('select_box1');
  if (assistDropdown) {
    assistDropdown.addEventListener('change', function() {
      const selectedValue = this.value;
      if (selectedValue && selectedValue !== 'Go To...') {
        showSection(selectedValue);
      }
    });
  }
  
  // Handle assist buttons
  const assistButtons = document.querySelectorAll('[id^="assist"]');
  assistButtons.forEach(button => {
    button.addEventListener('click', function() {
      const sectionMap = {
        'assist1': 'div-1',
        'assist2': 'div-2',
        'assist3': 'div-3',
        'assist4': 'div-4',
        'assist5': 'div-5'
      };
      
      const sectionId = sectionMap[this.id];
      if (sectionId) {
        showSection(sectionId);
      }
    });
  });
};

// Form validation helpers
export const validateStep = (stepNumber) => {
  // Add validation logic for each step
  switch (stepNumber) {
    case 0:
      return validateTripPurpose();
    case 1:
      return validateTravelGroup();
    case 2:
      return validateTravelerType();
    // Add more cases as needed
    default:
      return true;
  }
};

const validateTripPurpose = () => {
  const checkboxes = document.querySelectorAll('input[name="tripPurpose"]:checked');
  return checkboxes.length > 0;
};

const validateTravelGroup = () => {
  const radio = document.querySelector('input[name="travel_group"]:checked');
  return radio !== null;
};

const validateTravelerType = () => {
  const radio = document.querySelector('input[name="describe"]:checked');
  return radio !== null;
};

// Export form data
export const getFormData = () => {
  const formData = {
    tripPurpose: [],
    travelGroup: '',
    travelerType: '',
    destination: {
      hasDestination: false,
      destinationName: '',
      climate: '',
      terrain: '',
      pace: '',
      specificRegions: ''
    },
    transportation: {
      type: '',
      ecoFriendly: ''
    },
    accommodation: {
      important: [],
      propertyType: [],
      roomPreferences: []
    },
    experiences: {
      moments: [],
      needGuide: false,
      languagePreference: false
    },
    budget: {
      comfort: [],
      budgetPer: '',
      currency: '',
      paymentMode: ''
    },
    travelPlans: '',
    finalDetails: {
      fullName: '',
      age: '',
      whatsapp: '',
      email: '',
      phone: ''
    }
  };
  
  // Collect trip purpose
  const tripPurposeCheckboxes = document.querySelectorAll('input[name="tripPurpose"]:checked');
  tripPurposeCheckboxes.forEach(checkbox => {
    formData.tripPurpose.push(checkbox.value);
  });
  
  // Collect travel group
  const travelGroupRadio = document.querySelector('input[name="travel_group"]:checked');
  if (travelGroupRadio) {
    formData.travelGroup = travelGroupRadio.value;
  }
  
  // Add more data collection as needed
  
  return formData;
};